// extracted by mini-css-extract-plugin
export default {"container":"DeclinePopup_container__teG5H","popup":"DeclinePopup_popup__e5ff4","title":"DeclinePopup_title__sjK1E","btnWrapper":"DeclinePopup_btnWrapper__Lg+OI"};